"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    static WIN_NUMBER = 2048;
    static STATUS_PLAYING = "playing";
    static STATUS_IDLE = "idle";
    static STATUS_LOSE = "lose";
    static STATUS_WIN = "win";
    static DEFAULT_STATE = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ];
    constructor(initialState = $a5fd07fa01589658$var$Game.DEFAULT_STATE){
        this.initialState = initialState;
        this.state = this.deepCloneArray(this.initialState);
        this.status = $a5fd07fa01589658$var$Game.STATUS_IDLE;
        this.score = 0;
    }
    deepCloneArray(arr) {
        return arr.map((row)=>[
                ...row
            ]);
    }
    moveLeft() {
        // [2, 2, 4, 0]
        if (this.status === $a5fd07fa01589658$var$Game.STATUS_WIN || this.status === $a5fd07fa01589658$var$Game.STATUS_LOSE || this.status === $a5fd07fa01589658$var$Game.STATUS_IDLE) return;
        const prevState = JSON.stringify(this.state);
        for(let i = 0; i < this.state.length; i++){
            let row = this.state[i].filter((val)=>val !== 0); // [2, 2, 4]
            for(let j = 0; j < row.length - 1; j++)if (row[j] === row[j + 1]) {
                row[j] *= 2;
                row[j + 1] = 0; // [4, 0, 4]
                if (row[j] === $a5fd07fa01589658$var$Game.WIN_NUMBER) this.status = $a5fd07fa01589658$var$Game.STATUS_WIN;
                this.score += row[j];
            }
            row = row.filter((val)=>val !== 0); // [4, 4]
            while(row.length < this.state[i].length)row.push(0);
             // [4, 4, 0, 0]
            this.state[i] = row;
        }
        if (prevState !== JSON.stringify(this.state)) this.addRandomTile();
        if (!this.movesAvailable()) this.status = $a5fd07fa01589658$var$Game.STATUS_LOSE;
    }
    moveRight() {
        if (this.status === $a5fd07fa01589658$var$Game.STATUS_WIN || this.status === $a5fd07fa01589658$var$Game.STATUS_LOSE || this.status === $a5fd07fa01589658$var$Game.STATUS_IDLE) return;
        const prevState = JSON.stringify(this.state);
        // [0, 4, 2, 2]
        for(let i = 0; i < this.state.length; i++){
            let row = this.state[i].filter((val)=>val !== 0); // [4, 2, 2]
            for(let j = row.length - 1; j > 0; j--)if (row[j] === row[j - 1]) {
                row[j] *= 2;
                row[j - 1] = 0;
                if (row[j] === $a5fd07fa01589658$var$Game.WIN_NUMBER) this.status = $a5fd07fa01589658$var$Game.STATUS_WIN;
                this.score += row[j]; // [4, 0, 4]
            }
            row = row.filter((val)=>val !== 0); // [4, 4]
            while(row.length < this.state[i].length)row.unshift(0);
             // [0, 0, 4, 4]
            this.state[i] = row;
        }
        if (prevState !== JSON.stringify(this.state)) this.addRandomTile();
        if (!this.movesAvailable()) this.status = $a5fd07fa01589658$var$Game.STATUS_LOSE;
    }
    moveUp() {
        if (this.status === $a5fd07fa01589658$var$Game.STATUS_WIN || this.status === $a5fd07fa01589658$var$Game.STATUS_LOSE || this.status === $a5fd07fa01589658$var$Game.STATUS_IDLE) return;
        const prevState = JSON.stringify(this.state);
        for(let col = 0; col < this.state[0].length; col++){
            let column = [];
            for(let row = 0; row < this.state.length; row++)if (this.state[row][col] !== 0) column.push(this.state[row][col]);
            for(let i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                column[i] *= 2;
                column[i + 1] = 0;
                if (column[i] === $a5fd07fa01589658$var$Game.WIN_NUMBER) this.status = $a5fd07fa01589658$var$Game.STATUS_WIN;
                this.score += column[i];
            }
            column = column.filter((val)=>val !== 0);
            while(column.length < this.state.length)column.push(0);
            for(let row = 0; row < this.state.length; row++)this.state[row][col] = column[row];
        }
        if (prevState !== JSON.stringify(this.state)) this.addRandomTile();
        if (!this.movesAvailable()) this.status = $a5fd07fa01589658$var$Game.STATUS_LOSE;
    }
    moveDown() {
        if (this.status === $a5fd07fa01589658$var$Game.STATUS_WIN || this.status === $a5fd07fa01589658$var$Game.STATUS_LOSE || this.status === $a5fd07fa01589658$var$Game.STATUS_IDLE) return;
        const prevState = JSON.stringify(this.state);
        for(let col = 0; col < this.state[0].length; col++){
            let column = [];
            for(let row = 0; row < this.state.length; row++)if (this.state[row][col] !== 0) column.push(this.state[row][col]);
            for(let i = column.length - 1; i > 0; i--)if (column[i] === column[i - 1]) {
                column[i] *= 2;
                column[i - 1] = 0;
                if (column[i] === $a5fd07fa01589658$var$Game.WIN_NUMBER) this.status = $a5fd07fa01589658$var$Game.STATUS_WIN;
                this.score += column[i];
            }
            column = column.filter((val)=>val !== 0);
            while(column.length < this.state.length)column.unshift(0);
            for(let row = 0; row < this.state.length; row++)this.state[row][col] = column[row];
        }
        if (prevState !== JSON.stringify(this.state)) this.addRandomTile();
        if (!this.movesAvailable()) this.status = $a5fd07fa01589658$var$Game.STATUS_LOSE;
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.state;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.status = $a5fd07fa01589658$var$Game.STATUS_PLAYING;
        this.addRandomTile();
        this.addRandomTile();
    }
    restart() {
        this.state = this.deepCloneArray(this.initialState);
        this.score = 0;
        this.status = $a5fd07fa01589658$var$Game.STATUS_IDLE;
    }
    addRandomTile() {
        const emptyTiles = [];
        for(let i = 0; i < this.state.length; i++){
            for(let j = 0; j < this.state[i].length; j++)if (this.state[i][j] === 0) emptyTiles.push({
                x: i,
                y: j
            });
        }
        const randomIndex = Math.floor(Math.random() * emptyTiles.length);
        const { x: x, y: y } = emptyTiles[randomIndex];
        this.state[x][y] = Math.random() < 0.9 ? 2 : 4;
    }
    movesAvailable() {
        for(let i = 0; i < this.state.length; i++)for(let j = 0; j < this.state[i].length; j++){
            if (this.state[i][j] === 0) return true;
            if (i > 0 && this.state[i][j] === this.state[i - 1][j]) return true;
            if (i < this.state.length - 1 && this.state[i][j] === this.state[i + 1][j]) return true;
            if (j > 0 && this.state[i][j] === this.state[i][j - 1]) return true;
            if (j < this.state[i].length - 1 && this.state[i][j] === this.state[i][j + 1]) return true;
        }
        return false;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$fieldCells = document.querySelectorAll(".field-cell");
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$button.classList.toggle("start");
    $09e991522ca7e64e$var$button.classList.toggle("restart");
    if ($09e991522ca7e64e$var$button.classList.contains("restart")) {
        $09e991522ca7e64e$var$button.textContent = "Restart";
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$updateGame();
        document.addEventListener("keydown", $09e991522ca7e64e$var$handleKeyPress);
    } else {
        $09e991522ca7e64e$var$button.textContent = "Start";
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$updateGame();
    }
});
function $09e991522ca7e64e$var$handleKeyPress(e) {
    switch(e.key){
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$updateGame();
}
function $09e991522ca7e64e$var$updateGame() {
    $09e991522ca7e64e$var$updateScore();
    $09e991522ca7e64e$var$updateBoard();
    $09e991522ca7e64e$var$updateMessage();
}
function $09e991522ca7e64e$var$updateScore() {
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
}
function $09e991522ca7e64e$var$updateBoard() {
    const state = $09e991522ca7e64e$var$game.getState();
    for(let i = 0; i < state.length; i++)for(let j = 0; j < state[i].length; j++){
        const cell = $09e991522ca7e64e$var$fieldCells[i * state.length + j];
        cell.textContent = state[i][j] === 0 ? "" : state[i][j];
        cell.className = "field-cell";
        if (state[i][j] !== 0) cell.classList.add(`field-cell--${state[i][j]}`);
    }
}
function $09e991522ca7e64e$var$updateMessage() {
    const statusGame = $09e991522ca7e64e$var$game.getStatus();
    const messageContainer = document.querySelector(".message-container");
    const messages = messageContainer.querySelectorAll(".message");
    messages.forEach((message)=>message.classList.add("hidden"));
    if (statusGame === $a5fd07fa01589658$exports.STATUS_LOSE) messageContainer.querySelector(".message-lose").classList.remove("hidden");
    else if (statusGame === $a5fd07fa01589658$exports.STATUS_WIN) messageContainer.querySelector(".message-win").classList.remove("hidden");
    else if (statusGame === $a5fd07fa01589658$exports.STATUS_IDLE) messageContainer.querySelector(".message-start").classList.remove("hidden");
}


//# sourceMappingURL=index.76816a63.js.map
